// import { AddLog, AddLogButton } from "components/timesheet/add-log";
import {
  AddDraftLog,
  AddDraftLogButton,
} from "components/timesheet/add-draft-log";
import { HEADER_CONTENT_PORTAL_ID } from "utils";
import { HeaderDescription, HeaderTitle } from "components/timesheet/header";
import {
  DraftTimesheetEntries,
  TimesheetLoading,
  TimesheetRoot,
} from "components/timesheet/timesheet";
import { isValid, parseISO } from "date-fns";

import { useNavigate, useSearchParams } from "react-router-dom";
import { DatePicker } from "components/date-picker";
import DraftEntryCard from "components/timesheet/card/draft-entry";
import { Portal } from "@radix-ui/react-portal";
import DraftTimesheetLogLayout from "../../layout";
import { DraftTimesheetLogProvider } from "components/timesheet/context/draft-log";
import { formatDateForAPI } from "utils/utils";
import { useState, useEffect } from "react";
import { usePortal } from "hooks";
import TimesheetLogDayLoader from "@/modules/timesheet/logs/views/day/loader";
import HeaderPortal from "components/portal/header-portal";
import Lock from "components/timesheet/lock";
import LockCard from "components/timesheet/card/lock";
import UnlockTimesheetDialog from "@/modules/timesheet/logs/components/unlock/dialog";
import { Button } from "ui";
import { Icon } from "components";
import { LOCK_OPEN } from "icons";

export default function DraftTimesheetLogDay() {
  const [searchParams, setSearchParams] = useSearchParams();
  const day = searchParams.get("date") || formatDateForAPI(new Date());
  
  const [showUnlockTimesheetDialog, setShowUnlockTimesheetDialog] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    const parsed = parseISO(day);
    if (!isValid(parsed)) {
      navigate("/timesheet", { replace: true });
    }
  }, [day, navigate]);

  const headerContentPortal = usePortal({
    elementId: HEADER_CONTENT_PORTAL_ID,
  });

  return (
    <DraftTimesheetLogLayout>
      <HeaderPortal className="flex gap-3">
        <DatePicker day={day} setSearchParams={setSearchParams} />
      </HeaderPortal>
      <DraftTimesheetLogProvider date={day}>
        <TimesheetLoading>
          <TimesheetLogDayLoader />
        </TimesheetLoading>
        <TimesheetRoot>
          <div className=" lg:px-6 px-4">
            <div className="flex flex-col gap-6">
              <div className="flex justify-between md:items-center md:gap-6 gap-4 md:flex-row flex-col">
                <Portal container={headerContentPortal}>
                  <div>
                    <div className="flex items-center">
                      <HeaderTitle className="text-xl font-semibold " />
                    </div>
                    <HeaderDescription className="text-sm text-muted-foregroun mt-1" />
                  </div>
                </Portal>
                <HeaderPortal>
                  <div className="flex gap-6 justify-end items-center flex-row-reverse md:flex-row order-2">
                    <Lock>
                      <AddDraftLogButton />
                    </Lock>
                    <Lock show>
                      <Button
                        onClick={() => setShowUnlockTimesheetDialog(true)}
                        variant="outline"
                      >
                        <Icon icon={LOCK_OPEN} /> Unlock This Day
                      </Button>{" "}
                    </Lock>
                  </div>
                </HeaderPortal>
              </div>
            </div>
            <div className={" flex flex-wrap items-stretch gap-4.5 py-1"}>
              <Lock show>
                <LockCard onClick={() => setShowUnlockTimesheetDialog(true)} />
              </Lock>
              <DraftTimesheetEntries>
                {({ entry }) => (
                  <DraftEntryCard
                    key={entry.id}
                    entry={entry}
                    href={entry.id}
                  />
                )}
              </DraftTimesheetEntries>
              <Lock>
                <AddDraftLog />
              </Lock>
            </div>
          </div>
        </TimesheetRoot>
      </DraftTimesheetLogProvider>
      <UnlockTimesheetDialog
        open={showUnlockTimesheetDialog}
        onOpenChange={setShowUnlockTimesheetDialog}
        date={day}
      />
    </DraftTimesheetLogLayout>
  );
}
